import React, { useEffect, useState } from 'react';
import { Gift, Loader2, Users } from 'lucide-react';
import { getStoredRefCode } from '../../lib/refLink';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Surfaces an "[Coach X] invited you — 30-day free trial" banner when a user
 * lands via /?ref=CODE. Validates the code with the backend before showing.
 * Renders nothing on invalid / missing codes.
 */
export default function ReferralBanner({ className = '' }) {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = getStoredRefCode();
    if (!stored) { setLoading(false); return; }
    fetch(`${API}/api/referral/lookup/${encodeURIComponent(stored)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (data?.referrer_username) setInfo({ ...data, code: stored }); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || !info || dismissed) return null;

  return (
    <div
      className={`relative bg-gradient-to-r from-emerald-500 via-emerald-400 to-amber-300 text-stone-900 rounded-2xl px-4 py-3 shadow-lg border border-emerald-600/40 ${className}`}
      data-testid="referral-banner"
    >
      <div className="flex items-center gap-3 pr-7">
        <div className="w-10 h-10 rounded-full bg-stone-900 text-amber-300 flex items-center justify-center shrink-0">
          <Gift size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[11px] uppercase tracking-wider font-bold text-stone-800 leading-tight">
            Coach <span className="text-emerald-900">{info.referrer_username}</span> invited you
          </p>
          <p className="text-base font-bold leading-tight">
            Your free trial is <span className="text-emerald-900">{info.bonus_trial_days || 30} days</span> · auto-applied at signup
          </p>
        </div>
        <Users size={28} className="text-stone-900/30 shrink-0 hidden md:block" />
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="absolute top-2 right-2 w-6 h-6 rounded-full hover:bg-stone-900/10 flex items-center justify-center text-stone-700"
        aria-label="Dismiss"
        data-testid="referral-banner-dismiss"
      >
        ×
      </button>
    </div>
  );
}
